import MenuIcon from '../../menus/model/MenuIcon';
import ProjectLastSectionFirstTypeTranslations from './ProjectLastSectionFirstTypeTranslations';
import ProjectsNumberDescComponent from './ProjectsNumberDescComponent';
export default class ProjectLastSectionFirstType {
    constructor(projects) {
        const { id, projects_number_desc_component, bottom_right_image, top_left_image, work_details_image, translations } = projects;
        this.id = id;
        this.projects_number_desc_component = projects_number_desc_component
            ? projects_number_desc_component.map(element => new ProjectsNumberDescComponent(element))
            : [];
        this.translations = translations
            ? translations.map(translation => new ProjectLastSectionFirstTypeTranslations(translation))
            : [];
        this.bottom_right_image = bottom_right_image
            ? new MenuIcon(bottom_right_image)
            : undefined;
        this.top_left_image = top_left_image ? new MenuIcon(top_left_image) : undefined;
        this.work_details_image = work_details_image
            ? new MenuIcon(work_details_image)
            : undefined;
    }
}
